<template>
  <div class="items-end">
    <v-card shaped elevation="10" class="p-3" :loading="loading">
      <div class="flex flex-col">
        <div class="w-2/3 flex">
          <label class="flex flex-col w-1/2 pb-6 pr-3">
            <Lynx-Label label="Data Inicial" />
            <b-datepicker
              v-model="form.data_inicio"
              placeholder="Selecione uma data"
              :date-formatter="
                (date) => moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')
              "
              :date-parser="(date) => new Date(date)"
              :month-names="monthNames"
              :day-names="dayNames"
              :years-range="[-20, 10]"
              icon="calendar-today"
              locale="pt-BR"
            />
          </label>
          <label class="flex flex-col w-1/2 pb-6 pr-3">
            <Lynx-Label label="Data Final" />
            <b-datepicker
              v-model="form.data_fim"
              placeholder="Selecione uma data"
              :date-formatter="
                (date) => moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')
              "
              :date-parser="(date) => new Date(date)"
              :month-names="monthNames"
              :day-names="dayNames"
              icon="calendar-today"
              :years-range="[-20, 10]"
            />
          </label>

          <b-button
            style="margin-top: 30px"
            @click.native="fetchValues()"
            type="is-primary"
            >buscar</b-button
          >
          <b-button
            style="margin-top: 30px; margin-left: 10px"
            @click.native="clearDate()"
            type="is-warning"
            >Limpar Datas</b-button
          >
          <b-button
            :disabled="!form.data_fim || !form.data_inicio"
            text="gerar"
            type="is-success"
            style="margin-top: 30px; margin-left: 10px"
            @click.native="canceladosRelatorio()"
            >Relatorio</b-button
          >
        </div>
      </div>
      <div class="flex absolute right-0">
        <b-select v-model="maxVal">
          <option :value="auto_grafico">{{ auto_grafico }}</option>

          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="40">40</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="120">120</option>
          <option value="150">150</option>
          <option value="250">250</option>
        </b-select>
      </div>
      <h2 class="text-lg md:text-base text-neutral-600">
        {{ header.title }}
      </h2>
      <div class="flex justify-center w-full" v-if="loading">
        <Lynx-Spinner size="12" />
      </div>
      <div v-else>
        <div class="mt-5" id="chart">
          <apexchart
            type="bar"
            height="500"
            :options="chartOptions"
            :series="series"
          ></apexchart>
        </div>

        <b-table
          v-if="empresas"
          :columns="columns"
          :data="empresas"
          :per-page="perPage"
          :paginated="true"
          default-sort-direction="asc"
          default-sort="id"
          hoverables
          class="w-full rounded-t-none table-responsive"
          style="font-size: 12px"
        >
          <template v-slot="props">
            <b-table-column field="id" v-text="props.row.id" />
            <b-table-column
              field="razao_social"
              v-text="props.row.razao_social"
            />
            <b-table-column field="motivo">
              {{ props.row.motivo }}
            </b-table-column>
            <!-- <b-table-column field="cep" v-text="props.row.cep" /> -->

            <b-table-column field="data_encerramento">{{
              props.row.data_encerramento | formatEnToBr
            }}</b-table-column>
            <b-table-column field="acoes">
              <v-btn
                icon
                color="success"
                @click.native="searchEmpresa(props.row)"
                ><v-icon>mdi-arrow-right-bold-circle-outline</v-icon></v-btn
              >
              <v-btn icon color="warning" @click.native="showLogs(props.row)"
                ><v-icon>mdi-eye</v-icon></v-btn
              >
            </b-table-column>
          </template>
          <template #empty>
            <Not-Found-Data
              text="Nenhuma Atividade para a pesquisa informada"
            />
          </template>
        </b-table>
      </div>
    </v-card>

    <v-snackbar
      v-if="snackLogs"
      color="primary"
      shaped
      v-model="snackLogs"
      :vertical="false"
    >
      <span style="font-size: 15px"
        >AUTOR: {{ datalogs.autor }} <br />
        Descrição: {{ datalogs.descricao }}
      </span>

      <br />
      <!-- <span style="font-size: 15px; margin-top: 10px;">DELETOU: {{ user_up.toUpperCase() }} </span> -->

      <template v-slot:action="{ attrs }">
        <v-btn
          color="error"
          icon
          v-bind="attrs"
          @click.native="snackLogs = false"
        >
          <v-icon large> mdi-close </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import PieChart from "@/components/Chart/PieChart";
import NotFoundData from "@/components/layouts/NotFoundData";
import { quantityCompaniesChurn } from "@/services/requests/charts";
import { formatEnToBr } from "@/utils/momentHelpers";
import bus from "@/services/bus";
import { empresasShowRequest } from "@/services/requests/empresas";
import moment from "moment";
import { dayNames, monthNames } from "@/utils/utils";
import { formatBrToEn } from "@/utils/momentHelpers";

export default {
  name: "ResumoChurn",
  components: { PieChart, NotFoundData },
  data() {
    return {
      header: {
        title: "Resumo Churn ",
      },

      dayNames,
      monthNames,
      loading: false,
      values: {},
      maxVal: "120",
      ok: false,
      position: null,
      loadingChart: true,
      auto_grafico: 0,
      notFoundData: false,
      isValor: true,
      notFoundMessage: "",
      empresas: null,
      currentPage: 1,
      perPage: 10,
      loading: false,
      snackLogs: false,
      datalogs: {},
      columns: [
        {
          field: "id",
          label: "id",
          sortable: true,
          searchable: true,
          width: 130,
          // numeric: true,
        },

        {
          field: "razao_social",
          label: "Razao Social",
          sortable: false,
          searchable: true,
        },

        {
          field: "motivo",
          label: "Motivo",
          sortable: false,
        },
        {
          field: "data_encerramento",
          label: "Encerramento",
          sortable: true,
        },

        {
          field: "acoes",
          label: "Ações",
        },
      ],
      form: {
        data_inicio: null,
        data_fim: null,
      },
    };
  },
  filters: {
    formatEnToBr,
  },
  watch: {
    // maxVal(){
    //   chartOptions.yaxis.max =this.maxVal
    // },
    position() {
      console.log(this.position);
      this.empresas =
        this.values.datasets[0].empresas[this.position.seriesIndex][
          this.position.dataPointIndex
        ];
      console.log(this.empresas);
    },
  },
  computed: {
    chartOptions() {
      let a;
      let data = {
        chart: {
          type: "bar",
          height: 700,
          events: {
            click: (event, chartContext, config) => {
              console.log(config);
              const serializedConfig = {
                seriesIndex: config.seriesIndex,
                dataPointIndex: config.dataPointIndex,
                // Adicione outras propriedades que você precisa de 'config'
              };
              this.position = serializedConfig;
            },
          },
          stacked: true,
          // stackType: '100%',
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
            barHeight: "100%",
            endingShape: "rounded",
            dataLabels: {
              hideOverflowingLabels: true,
              position: "center",
              total: {
                enabled: true,
                style: {
                  fontSize: "10px",
                  fontWeight: 900,
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: true,
          offsetX: 0,
          style: {
            fontSize: "12px",
            colors: ["#fff"],
          },
          //     stroke: {
          //     show: true,
          //     width: 1,
          //     colors: ['#fff']
          // },
        },
        xaxis: {
          labels: {
            rotate: -45,
          },
          categories: this.values.label,
          tickPlacement: "on",
        },
        yaxis: {
          show: true,
          showAlways: true,
          max: 150,
          forceNiceScale: false,
          floating: false,
          decimalsInFloat: undefined,
        },
        // legend: {
        //   position: 'top',
        //   offsetY: 1,
        //   enabled: true
        // },
        fill: {
          opacity: 1,
          fontSize: "10px",
        },
        colors: [
          "#ff0fc9", // Coral
          "#3498DB", // Dodger Blue
          "#22AA45", // Emerald Green
          "#E74C3C", // Light Coral
          "#F39662", // Light Salmon
          "#9B59B6", // Amethyst Purple
          "#333300", // Olive
          "#ee7600", // Carrot Orange
        ],
      };
      data.yaxis.max = parseInt(this.maxVal);

      //   data.legend.formatter = function (seriesName, opts) {
      //     return (
      //       seriesName +
      //       ":  " +
      //       parseInt(
      //         (opts.w.globals.series[opts.seriesIndex] * parseInt(sum)) / 100
      //       )
      //     );
      //   };
      //   return data;
      // } else {
      //   data.legend.formatter = function (seriesName, opts) {
      //     return (
      //       seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + "%"
      //     );
      //   };
      return data;
      // }
    },
    series() {
      // Check if series is defined
      if (!this.values || !this.values.datasets) {
        return [];
      }

      const newData = JSON.parse(
        JSON.stringify(this.values.datasets[0].data.series)
      );

      // Iterar sobre cada série
      newData.forEach((serie) => {
        // Filtrar os valores maiores que maxVal e definir como 0
        serie.data = serie.data.map((value) =>
          value > this.maxVal ? 0 : value
        );
      });

      // Retornar o novo array ajustado
      return newData;
    },

    // total() {
    //   let dataArr = [
    //    this.values.datasets[0].data.series
    //   ];
    //   let sum = 0;

    //   for (var i = 0; i < dataArr.length; i++) {
    //     sum += parseInt(dataArr[i].data);
    //   }
    //   return sum;
    // },
  },
  methods: {
    moment,
    clearDate() {
      this.form = {
        data_inicio: null,
        data_fim: null,
      };
    },
    async fetchValues() {
      this.loading = true;

      // let a = {};
      // if (this.form.data_inicio && this.form.data_fim) {
      //   a = {
      //     data_inicio: formatBrToEn(this.form.data_inicio),
      //     data_fim: formatBrToEn(this.form.data_fim),
      //   };
      // } else {
      //   a = {
      //     data_inicio: this.form.data_inicio,
      //     data_fim: this.form.data_fim,
      //   };
      // }

      await quantityCompaniesChurn(this.form)
        .then((res) => {
          let maxVal = 0;
          let seriesData = res.data.datasets[0].data.series;

          for (let index = 0; index < seriesData[0].data.length; index++) {
            let currentMax = seriesData.reduce((sum, item) => sum + item.data[index], 0);
            if(currentMax) maxVal = Math.max(maxVal, currentMax);
           
          }
           
          let final = Math.ceil(maxVal / 5) * 5;
          final = Math.max(final, 10);
          this.auto_grafico = final;
          console.log(maxVal);
          this.maxVal = final;
          this.values = res.data;
        })
        .finally(() => (this.loading = false));
      // console.log([this.values.datasets[0].data.series]);
    },
    searchEmpresa(empresa) {
      bus.globalLoading = true;
      empresasShowRequest(empresa.id)
        .then((res) => {
          this.$store.dispatch("setEmpresa", res.data.data);
          this.$router.push({ name: "empresas.show" });
        })
        .catch(() => this.$snack.error("Empresa não encontrada"))
        .finally(() => (bus.globalLoading = false));
    },
    async canceladosRelatorio() {
      this.loading = true;

      //  console.log(formatBrToEn(this.form.data_competencia))
      window.open(
        `${process.env.VUE_APP_API_URL}/relatorio/cancelados` +
          `?token=${this.$store.getters.getToken}&data_inicial=${formatBrToEn(
            this.form.data_inicio
          )}&data_final=${formatBrToEn(this.form.data_fim)}`,
        "_blank"
      );

      this.loading = false;
    },

    // formatter(value) {
    //   console.log(this.total);
    //   return ((value * 100) / this.total).toFixed(2);
    // },
    showLogs(data) {
      this.snackLogs = false;

      this.snackLogs = true;
      this.datalogs = data;
    },
  },
  mounted() {
    this.fetchValues();
  },
};
</script>
